import React from 'react';
import {useParams} from 'react-router-dom';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Card} from 'semantic-ui-react';

import ExpandableProjectList, {
  SeeAllLink,
} from '../../components/ExpandableProjectList';
import {useProfilePageProjectsQuery} from '../../generated/graphql';
import {Project} from '../../graphql/projects';
import {Graph} from '../../types/graphql';
import {allProjects} from '../../util/urls';
import {ProjectCardSkeleton} from './../../components/ProjectCard';

export const ProjectSkeletons = ({entityName}: {entityName: string}) => {
  return (
    <>
      <Card.Group>
        {Array(6)
          .fill({})
          .map((_, i) => (
            <ProjectCardSkeleton key={i} />
          ))}
      </Card.Group>
      <SeeAllLink to={allProjects(entityName)} />
    </>
  );
};
type LoadableProjectListProps = {
  editable: boolean;
};
export const LoadableProjectList = ({editable}: LoadableProjectListProps) => {
  const {entityName} = useParams<{entityName: string}>();

  const profilePageProjectsQuery = useProfilePageProjectsQuery({
    variables: {username: entityName},
  });
  if (profilePageProjectsQuery.loading) {
    return <ProjectSkeletons entityName={entityName} />;
  }
  const projects = profilePageProjectsQuery.data?.user?.projects;
  return (
    <ExpandableProjectList
      entityName={entityName}
      isReadOnly={!editable}
      projects={projects as unknown as Graph<Project>}
      suppressHeader
    />
  );
};
